<template>
	<div class="pay-page container">
		<div class="top clearfix">
			<div class="left">
				<div>订单编号：{{$route.query.o}}</div>
			</div>
			<div class="right">应付金额：￥{{$route.query.m}}</div>
		</div>
		<div class="bottom">
			<el-tabs v-model="activeName" type="border-card">
				<el-tab-pane label="微信支付" name="wechat">
					<div class="wechat clearfix">
						<div class="wechat-logo">
							<img src="@/assets/images/pay/WePayLogo.png" alt />
						</div>
						<div class="wechat-qrcode">
							<div class="qrcode-img">
								<div id="qrcode" v-loading="wechatLoading" style="width:160px;height:160px"></div>
							</div>
							<div class="wechat-describe">
								<img src="@/assets/images/pay/wechatDescribe.png" alt />
							</div>
						</div>
						<div class="wechat-text">
							<div class="wechat-btn" @click="backToOrder">已支付？点此返回</div>
						</div>
					</div>
				</el-tab-pane>
				<el-tab-pane label="银联支付" name="UnionPay">
					<div class="UnionPay clearfix">
						<div class="UnionPay-logo">
							<img src="@/assets/images/pay/UnionPay.png" alt />
						</div>
						<div class="UnionPay-content">
							<el-radio-group v-model="UnionPayType">
								<el-radio label="union">个人网银</el-radio>
								<el-radio label="union_b2b">企业网银</el-radio>
							</el-radio-group>
							<div class="UnionPay-submit">
								<el-button type="primary" size="mini" @click="goPay">确认支付</el-button>
							</div>
						</div>
					</div>
				</el-tab-pane>
				<el-tab-pane label="支付宝支付" name="alipay">暂未开通</el-tab-pane>
			</el-tabs>
		</div>
	</div>
</template>
<script>
import { pay } from "@/api/order";
import QRCode from "qrcodejs2";
export default {
	data() {
		return {
			activeName: "wechat",
			qrcode_timer: null,
			wechatLoading: false,
			UnionPayType: "union"
		};
	},
	watch: {
		activeName: {
			handler: function(val, oldVal) {
				if (val === "wechat") {
					let axiosData = {
						order_id: Number(this.$route.params.id),
						method: "wechat"
					};
					this.wechatLoading = true;
					pay(axiosData).then(res => {
						if (res && res.code === 200) {
							if (res.data.type === "qr_code") {
								this.createQrcode(res.data.data);
								this.qrcode_timer = Date.now();
							}
						} else {
							this.$message.error(res.message);
						}
					});
				}
			},
			immediate: true
		}
	},
	methods: {
		// 生成二维码
		createQrcode(data) {
			document.querySelector("#qrcode").innerHTML = "";

			this.$nextTick(() => {
				let qrcode = new QRCode("qrcode", {
					width: 160,
					height: 160, // 高度
					text: data // 二维码内容
				});
			});
			this.wechatLoading = false;
		},
		//确认支付
		goPay() {
			let axiosData = {
				order_id: Number(this.$route.params.id),
				method: this.UnionPayType
			};
			pay(axiosData).then(res => {
				if (res && res.code === 200) {
					if (res.data.type === "html") {
						let html = res.data.data;

						const div = document.createElement("div");
						div.innerHTML = html;
						document.body.append(div);
						let pay_form = document.querySelector("#pay_form");
						pay_form.setAttribute("target", "_self"); //本页面打开银联页面
						pay_form.submit(); //提交

						document.body.removeChild(div);
					} else {
						this.$message.error(res.message);
					}
				}
			});
		},
		//返回订单列表
		backToOrder() {
			this.$router.push("/home?tab=myOrder");
		}
	}
};
</script>
<style lang="scss" scoped>
.pay-page {
	.top {
		background: #f9f9f9;
		font-size: 15px;
		padding: 20px;
		.left {
			float: left;
			width: 50%;
			> div {
				margin-bottom: 10px;
			}
		}
		.right {
			float: right;
			width: 50%;
			text-align: right;
		}
	}
	.bottom {
		margin: 40px 0;
		.wechat {
			padding: 40px 0;
			.wechat-logo {
				width: 120px;
				float: left;
				img {
					width: 100%;
				}
			}
			.wechat-qrcode {
				float: left;
				margin-left: 100px;
				.qrcode-img {
					width: 160px;
					img {
						width: 100%;
					}
				}
			}
			.wechat-describe {
				width: 160px;
				margin-top: 10px;
				img {
					width: 100%;
				}
			}
			.wechat-text {
				margin-left: 20px;
				float: left;

				.wechat-btn {
					color: #fff;
					background: rgba(182, 5, 17, 0.5);
					padding: 2px 6px;
					margin-bottom: 20px;
					cursor: pointer;
					transition: all 0.3s;
					&:hover {
						background: rgba(182, 5, 17, 0.8);
					}
				}
			}
		}
		.UnionPay {
			padding: 40px 0;
			.UnionPay-logo {
				width: 120px;
				float: left;
				img {
					width: 100%;
				}
			}
			.UnionPay-content {
				float: left;
				margin-left: 100px;
			}
			.UnionPay-submit {
				margin-top: 60px;
			}
		}
	}
}
</style>
